<section class="profile" (click)="openProfile()">
  <i class="profile__icon profile-icon"></i>
</section>
